
















































import { Component, Vue } from "vue-property-decorator";
import Loading from "@/shared/components/loading.vue";
import Modal from "@/shared/components/modal.vue";
import SelectProduto from "@/shared/components/select-produto.vue";
import { ItemKit, Produto, ProdutosService } from "@/services/produtos.service";
import { required, maiorQue } from "@/shared/validators";
import InputMoeda from "@/shared/components/input-moeda.vue";
@Component({
  components: {
    Loading,
    Modal,
    SelectProduto,
    InputMoeda,
  },
})
export default class AdicionarItemKit extends Vue {
  idCatalogo: string | null = null;
  loading = false;

  produtoSelecionado = {} as Produto;
  itemKit = {} as ItemKit;

  rules = {
    quantidade: [required(), maiorQue(0)],
    valorVenda: [required()],
  };
  idProdutoPai: string | null = null;

  mounted() {
    this.itemKit.quantidade = 1;
  }

  async adicionarItem() {
    const form = this.$refs.form as any;
    this.loading = true;
    if (form.validate()) {
      if (this.idProdutoPai && this.produtoSelecionado.idProduto) {
        const command = {
          idProdutoPai: this.idProdutoPai,
          idProduto: this.produtoSelecionado.idProduto,
          quantidade: this.itemKit.quantidade,
        };

        await ProdutosService.adicionarItemKit(command);
        this.loading = false;
        this.$emit("novo-item");
      }
    }
  }

  fechar() {
    const modal = this.$refs.modal as Modal;
    modal.close(false);
  }

  public async novoItem(idProdutoPai: string, idCatalogo: string) {
    const modal = this.$refs.modal as Modal;
    this.idCatalogo = idCatalogo;
    this.idProdutoPai = idProdutoPai;
    modal.open();
  }
}
